import cx from "classnames";
import React from "react";

const Title = props => {
    return (
        <h3 className={cx('tracking-wide text-indigo-800 font-bold', props.className)}>
            {props.text}
        </h3>
    )
}

export default Title